import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const Reports = ({ apiBase }) => {
  const [salesReport, setSalesReport] = useState([]);
  const [commissionReport, setCommissionReport] = useState([]);
  const [funnelData, setFunnelData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const [salesRes, commissionRes, funnelRes] = await Promise.all([
        axios.get(`${apiBase}/reports/sales`),
        axios.get(`${apiBase}/reports/commissions`),
        axios.get(`${apiBase}/reports/conversion-funnel`)
      ]);
      setSalesReport(salesRes.data);
      setCommissionReport(commissionRes.data);
      setFunnelData(funnelRes.data);
    } catch (error) {
      console.error('Error fetching reports:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading reports...</div>;
  }

  const COLORS = ['#2563eb', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];

  return (
    <div>
      <h1 style={{ marginBottom: '24px' }}>Reports & Analytics</h1>

      {funnelData && (
        <div className="card">
          <h2 className="card-title">Conversion Funnel</h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={[
              { name: 'Leads', value: funnelData.leads },
              { name: 'Interested', value: funnelData.interested },
              { name: 'Inspection', value: funnelData.inspection },
              { name: 'Booked', value: funnelData.booked },
              { name: 'Sold', value: funnelData.sold }
            ]}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#2563eb" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}

      <div className="card">
        <h2 className="card-title">Channel Partner Commission Report</h2>
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Channel Partner</th>
                <th>Total Deals</th>
                <th>Total Commission</th>
                <th>GST</th>
                <th>Total Payable</th>
              </tr>
            </thead>
            <tbody>
              {commissionReport.map((cp, idx) => (
                <tr key={idx}>
                  <td>{cp.channel_partner_name}</td>
                  <td>{cp.total_deals || 0}</td>
                  <td>₹{formatCurrency(cp.total_commission || 0)}</td>
                  <td>₹{formatCurrency(cp.total_gst || 0)}</td>
                  <td>₹{formatCurrency(cp.total_payable || 0)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <h2 className="card-title">Sales Report</h2>
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Deal Number</th>
                <th>Client</th>
                <th>Project</th>
                <th>Sale Value</th>
                <th>Type</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {salesReport.map((sale) => (
                <tr key={sale.id}>
                  <td>{sale.deal_number}</td>
                  <td>{sale.client_name}</td>
                  <td>{sale.project_name}</td>
                  <td>₹{formatCurrency(sale.sale_value)}</td>
                  <td>{sale.sale_type}</td>
                  <td>{new Date(sale.sale_date).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0
  }).format(amount);
};

export default Reports;


